import { m } from 'framer-motion';
// @mui
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
// routes
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
// hooks
// auth
// components
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { varHover } from 'src/components/animate';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useSnackbar } from 'src/components/snackbar';
import { useBoolean } from 'src/hooks/use-boolean';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { logout } from 'src/store/slices/userSlice';
import { Tooltip } from '@mui/material';
import { useLogoutUserMutation } from 'src/store/Reducer/auth';
import { USER_TYPE_CONTRACTOR, USER_TYPE_SUPER_ADMIN } from 'src/config-global';

// ----------------------------------------------------------------------

const OPTIONS = [
  {
    label: 'Profile',
    linkTo: paths.dashboard.account,
    tab: 'profile'
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const open = useBoolean();

  const router = useRouter();

  const dispatch = useDispatch();

  const { user } = useMockedUser();

  const redux = useSelector((state) => state.user); 
  const device_id = redux?.device_id ||'abc';


  const [logoutUser ,{isLoading}] = useLogoutUserMutation();


  // const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const popover = usePopover();
  const role = user?.user_type === USER_TYPE_SUPER_ADMIN ? 'admin' : 'contractor';

  const handleLogout = async () => {
    try {
      const response = await logoutUser({role , device_id})
      if(!response?.error){
        enqueueSnackbar(response?.data?.message, { variant: 'success' });
        dispatch(logout())
        popover.onClose();
        router.replace('/');
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path, state) => {
    popover.onClose();
    router.push(path, state);
  };

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          // src={user?.photoURL}
          src={user?.photoURL || user?.image}
          alt={user?.displayName || 'User'}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {user?.displayName?.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Tooltip title={user?.displayName || 'Pressure Washer Contractor'}>
            <Typography variant="subtitle2" noWrap>
              {user?.displayName || 'Pressure Washer Contractor'}
            </Typography>
          </Tooltip>

          <Tooltip title={user?.email}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
              {user?.email}
            </Typography>
          </Tooltip>
        </Box>


        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(
              user?.user_type === USER_TYPE_SUPER_ADMIN ? paths.superAdminDashboard.account : user?.user_type===USER_TYPE_CONTRACTOR ?paths.dashboard.account:paths.shopAdminDashboard.account
              , { state: { tab: option.tab } })}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={open.onTrue}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Logout
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={open.value}
        onClose={open.onFalse}
        onConfirm={handleLogout}
        title="Logout"
        content="Are you sure you want to logout?"
        action={
          <LoadingButton onClick={handleLogout} variant='contained' color='error' loading={isLoading} disabled={isLoading}>
            Logout
          </LoadingButton>
        }
      />
    </>
  );
}
